import React, { Component } from 'react';
import Button from '../../components/UI/Button/Button'
import uuid from "uuid";
import classes from './ToolsContainer.module.css'
import Slider from '../../components/UI/Slider/Slider'

class ToolsContainer extends Component {
    state = {
        isAddingAnnotation: false,
        comment: {},
        labelCount: 0,
        brushColor: "red",
        showOptionalTools: false,

    }

    addCommentHandler = () => {
        let comment = {
            uuid: uuid.v4(),
            value: "Double click me!",
            x: 150,
            y: 150
        }
        this.setState({
            comment: comment
        }, () => {
            // console.log("[ToolsContainer][addCommentHandler] " + this.state.comment)
            this.props.getCommentHandler(this.state.comment)
        })

    }

    // downloadHandler = () => {                This function saves the canvas as an image
    //     this.props.downloadImageHandler()
    // }


    changeColorHandler = (event) => {
        this.setState({ brushColor: event.target.value })
        this.props.brushColorHandler(event.target.value)
    }

    showOptionalTools = () => {
        this.setState({ showOptionalTools: !this.state.showOptionalTools })
    }

    getSliderValueHandler = (value) => {
        this.props.changeBrushSizeHandler(value)
    }

    render() {
        const brushKit = (
            <React.Fragment>
                <select value={this.state.brushColor} onChange={this.changeColorHandler} style={{ backgroundColor: this.state.brushColor }}>
                    <option value={"red"} style={{ backgroundColor: "red" }}></option>
                    <option value={"blue"} style={{ backgroundColor: "blue" }}></option>
                    <option value={"yellow"} style={{ backgroundColor: "yellow" }}></option>
                    <option value={"black"} style={{ backgroundColor: "black" }}></option>
                    <option value={"white"} style={{ backgroundColor: "white" }}></option>
                </select>
                <Slider getSliderValueHandler={value => this.getSliderValueHandler(value)} brushSize={this.props.brushSize} />
            </React.Fragment>
        )
        const eraseKit = (
            <React.Fragment>
                <Slider getSliderValueHandler={value => this.getSliderValueHandler(value)} brushSize={this.props.brushSize} />
            </React.Fragment>
        )
        return (
            <div className={classes.toolsContainer}>
                <div className="pure-menu pure-menu-horizontal" style={{ display: "inline-block" }}>
                    <ul className="pure-menu-list">
                        <li className="pure-menu-item pure-menu-has-children pure-menu-allow-hover">
                            {this.props.isErasing ? <Button icon={"fas fa-eraser"} type={"button-tertiary"} gridClass={""} buttonName={"Eraser"} style={{ width: "100%" }} /> : <Button icon={"fas fa-paint-brush"} type={"button-quarternary"} gridClass={""} buttonName={"Brush"} style={{ width: "100%" }} />}
                            <ul className="pure-menu-children" style={{ bottom: "100%" }}>
                                <li className="pure-menu-item"><Button icon={"fas fa-comment-alt"} type={"button-primary"} gridClass={""} buttonName={"Comment"} style={{ width: "100%" }} onClick={() => this.addCommentHandler} /></li>
                                <li className="pure-menu-item"><Button icon={"fas fa-paint-brush"} type={"button-quarternary"} gridClass={""} buttonName={"Brush"} style={{ width: "100%" }} onClick={() => this.props.brushHandler} /></li>
                                <li className="pure-menu-item"><Button icon={"fas fa-eraser"} type={"button-tertiary"} gridClass={""} buttonName={"Eraser"} style={{ width: "100%" }} onClick={() => this.props.eraserHandler} /></li>
                            </ul>
                        </li>
                    </ul>
                    <Button icon={"fas fa-cog"} type={""} gridClass={""} buttonName={""} onClick={() => this.showOptionalTools} />

                    {this.state.showOptionalTools ?
                        (this.props.isErasing ? eraseKit : brushKit) : null}

                    <Button icon={"fas fa-upload"} type={"button-secondary"} gridClass={""} buttonName={"Submit"} onClick={this.props.submitImageHandler} />
                    <Button icon={"fas fa-times"} type={"button-error"} gridClass={""} buttonName={"Cancel"} onClick={this.props.cancelImageHandler} />

                </div>
            </div>
        )
    }
}
export default ToolsContainer;